import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useSidebarLayout} from "./SidebarProvider";
import {includes} from "underscore";

const whichSidebarEntryToHighlight = (page, subpage) => {
  if (includes(["reports"], page) && subpage) {
    return `${page}/${subpage}`;
  }
  if (includes(["compliance"], page)) {
    if (!includes(["summary", "plan", "research"], subpage)) {
      return "compliance/summary";
    }
    return `${page}/${subpage}`;
  }
  return page;
};

const SidebarLocationSync = () => {
  const location = useLocation();
  const {setCurrentPage} = useSidebarLayout();

  useEffect(() => {
    const [, page, subpage] = location.pathname.split("/");
    setCurrentPage(whichSidebarEntryToHighlight(page, subpage));
  }, [location.pathname]);

  return null;
};

export default SidebarLocationSync;
